<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" class="pr-sm-5">
      <DocumentInput
        id-element="cnpj"
        placeholder="Inserir"
        v-model="value.cnpj"
        required
        :rules="[requiredInput, isValidCnpjDocument]"
        label-text="CNPJ"
        document-type="cnpj"
      />
    </v-col>
    <v-col cols="12" sm="6" md="8">
      <BaseFormInput
        id-element="razao-social"
        placeholder="Inserir"
        v-model="value.razao_social"
        required
        :rules="[requiredInput]"
        label-text="Razão Social"
      />
    </v-col>
    <v-col cols="12">
      <BaseFormInput
        id-element="nome-fantasia"
        placeholder="Inserir"
        v-model="value.nome_fantasia"
        required
        :rules="[requiredInput]"
        label-text="Nome Fantasia"
      />
    </v-col>
    <v-col cols="12" sm="6" md="4" class="pr-sm-5">
      <BaseFormInput
        id-element="codigo-atividade"
        placeholder="Inserir"
        v-model="value.atividade_principal.codigo"
        required
        :rules="[requiredInput]"
        label-text="COD. Atividade"
        v-facade="maskCNAE"
      />
    </v-col>
    <v-col cols="12" sm="6" md="8">
      <BaseFormInput
        id-element="descr-atividade"
        placeholder="Inserir"
        v-model="value.atividade_principal.nome"
        required
        :rules="[requiredInput]"
        label-text="Descrição da Atividade"
      />
    </v-col>
  </v-row>
</template>

<script>
import { requiredInput, isValidCnpjDocument } from "@/utils/rules.js";
import { maskCNAE } from "@/utils/masks.js";
import DocumentInput from "@/components/form/DocumentInput.vue";

export default {
  props: {
    value: Object
  },
  data() {
    return {
      requiredInput,
      isValidCnpjDocument,
      maskCNAE
    };
  },
  components: { DocumentInput }
};
</script>
